import { AlertTriangle } from "lucide-react";
import { useUsage } from "../../contexts/UsageContext";

export function UsageLimitBanner() {
  const { usage } = useUsage();

  if (!usage || usage.remaining > 0) return null;

  const resetDate = new Date(usage.period_end).toLocaleDateString("fr-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="bg-red-900/50 border border-red-700 rounded-lg px-4 py-3 mx-4 mb-2 flex items-center gap-3">
      <AlertTriangle className="w-5 h-5 text-red-400 shrink-0" />
      <p className="text-sm text-red-200">
        Vous avez atteint votre limite mensuelle. Votre quota se réinitialise le {resetDate}.
      </p>
    </div>
  );
}
